module.exports = __webpack_public_path__ + "static/media/playbook-home.86cae853.jpg";